import { render, staticRenderFns } from "./CheckSession.vue?vue&type=template&id=06baa99e&"
import script from "./CheckSession.vue?vue&type=script&lang=js&"
export * from "./CheckSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06baa99e')) {
      api.createRecord('06baa99e', component.options)
    } else {
      api.reload('06baa99e', component.options)
    }
    module.hot.accept("./CheckSession.vue?vue&type=template&id=06baa99e&", function () {
      api.rerender('06baa99e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CheckSession.vue"
export default component.exports